/* eslint-disable no-shadow */
export interface DataServicesError extends Error {
  errors: string[];
}

class DataServicesErrorConstructor extends Error implements DataServicesError {
  private innerErrors: string[];

  constructor(...errors: string[]) {
    super(errors.values().next().value ?? 'The server returned an error');

    // This line is covered by 'will set the 'errors' property to a empty array' unit test, but 
    // it continues to show as not tested.
    /* c8 ignore next */
    this.innerErrors = errors ?? [];

    Object.setPrototypeOf(this, new.target.prototype);
  }

  get errors(): string[] { return this.innerErrors; }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DataServicesError = DataServicesErrorConstructor;
export default DataServicesError;

declare global {

  interface DataServicesError extends Error {
    readonly Errors: string[];
  }

  interface DataServicesErrorConstructor {
    new(...errors: string[]): DataServicesError;
    readonly prototype: DataServicesError;
  }

  // eslint-disable-next-line @typescript-eslint/naming-convention
  const DataServicesError: DataServicesErrorConstructor;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const windowLocal: any = window;
windowLocal.DataServicesError = windowLocal.DataServicesError || DataServicesError;
